import React from "react";
import { useLayoutOptionsState } from "../hooks/use-layout-options-state";
export function LayoutOptions() {
    const { handleChangeLayout, options } = useLayoutOptionsState();
    return (React.createElement("div", { className: "w-full flex justify-end" }, options?.map(({ identifier, icon, selected }) => (React.createElement("button", { key: identifier, className: `border border-primary p-2 ${selected ? "bg-primary" : "bg-secondary"} ${identifier === "list" ? "rounded-l-lg" : "rounded-r-lg"}`, onClick: () => handleChangeLayout(identifier) },
        React.createElement("div", { className: `${selected ? "text-secondary" : "text-primary"}` }, icon))))));
}
